import React from 'react'

const Dashboard = () => {
  return (
    <div>
      <h5>Dashboard</h5>
    </div>
  )
}

export default Dashboard
